<template lang="pug">
  .contenedor-interno(v-on-clickaway="close")
    .title
      span Tipos de permiso
    .search
      .control
        input.input(
          type="text",
          placeholder="Buscar...",
          v-model="searchTerm"
          @keyup.enter="selectFirst"
          @keyup.esc="close"
          ref="busqueda"
        )
    .data
      transition-group.contenedor-data(name="fade-smooth-two", tag="div")
        .usuario(
          v-if="!isLoading"
          v-for="(o,i) in filtered"
          :key="o.codigo"
          @click="seleccionarClick(o)"
        )
          span.codigo {{ o.codigo}} :
          span.descripcion {{ o.descripcion }}
      .is-loading.text-center(v-if="isLoading")
        span.icon
          i.fa.fa-spin.fa-spinner

</template>

<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'lookup_small_tipos_permiso',
  props: ['codigo'],
  data () {
    return {
      lista      : [],
      filtered   : [],
      searchTerm : '',
      isLoading  : true
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
    this.$refs.busqueda.focus()
  },
  watch : {
    searchTerm (value) {
      return this.sendSearch(value)
    }
  },
  methods: {
    fetch () {
      let vm = this
      apiGet(vm, '/permisos/tipo', {}, function (data) {
        vm.lista     = data.lista
        vm.filtered  = vm.lista
        vm.isLoading = false
        if (vm.codigo) {
          vm.searchTerm        = vm.codigo
          vm.sendSearch(vm.searchTerm)
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    selectFirst () {
      if (this.filtered.length === 0) {
        this.$emit('close')
      } else {
        this.$emit('selected', this.filtered[0])
        this.$emit('close')
      }
    },
    seleccionarClick (o) {
      this.$emit('selected', o)
      this.$emit('close')
    },
    close () {
      this.$emit('close', this.filtered[0])
    },
    sendSearch (value) {
      if (value) {
        value = value + ''
        this.filtered = this.lista.filter(e => {
          return e.descripcion.toLowerCase().includes(value.toLowerCase()) || (e.codigo + '').includes(value)
        })
      } else {
        this.filtered = this.lista
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    display flex
    flex-direction column

    .title
      margin 10px 5px 5px 5px
      font-size 17px
      border-bottom 1px solid #ccc
      padding-bottom 10px
      text-align center

    .search
      padding 5px 10px

    .data
      max-height: 180px;
      overflow-y: auto;
      .contenedor-box
        >*
          transition all .5s
          width 100%
      padding 10px
      .usuario
        background: #fff;
        border-radius: 3px;
        border: 1px solid #d6dadc;
        border-bottom-color: #c4c9cc;
        -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
        box-shadow: 0 1px 6px rgba(0,0,0,.15);
        display flex
        padding 10px
        margin-bottom 5px
        cursor pointer
        transition all .2s ease

        &:hover
          background-color: #edeff0;
          margin-left: 4px;
          -webkit-box-shadow: -8px 0 #959da17d;
          box-shadow: -8px 0 #959da17d;

        .codigo
          width 30px
        .descripcion
          flex 1
</style>



// WEBPACK FOOTER //
// Component_Lookup_Small_Tipos_Permiso.vue?7987a476